import linkifyHtml from 'linkify-html';

import { sanitizeHtml, SanitizeProfile } from './sanitize';

/**
 * Builds the `dangerouslySetInnerHTML` payload, sanitizing the HTML first.
 *
 * Defaults to the RICH profile (CMS authored content). Pass
 * `SanitizeProfile.USER_CONTENT` for anything a user can type.
 *
 * Re-exported from `utils/generic` for the legacy call sites.
 *
 * @param {string} htmlString
 * @param {string} [profile] one of `SanitizeProfile`
 * @returns {{ __html: string }}
 */
export const createMarkup = (htmlString, profile = SanitizeProfile.RICH) => {
  return { __html: sanitizeHtml(htmlString, profile) };
};

/**
 * Markup payload for user typed content — answers, comments, project
 * reflections. Turns bare URLs into links, then sanitizes with the stricter
 * USER_CONTENT profile (no embeds, no form controls).
 *
 * @param {string} content
 * @param {Object} [linkifyOptions] merged over `{ target: "_blank" }`
 * @returns {{ __html: string }}
 */
export const createUserContentMarkup = (content, linkifyOptions = {}) => {
  if (!content) return { __html: '' };

  const linkified = linkifyHtml(content, { target: '_blank', ...linkifyOptions });

  return createMarkup(linkified, SanitizeProfile.USER_CONTENT);
};
